import { type InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils/cn';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'h-11 w-full rounded-[var(--radius-btn)] border border-line bg-surface px-3.5 text-sm text-ink',
        'placeholder:text-muted focus-visible:border-teal-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500/30',
        'disabled:cursor-not-allowed disabled:opacity-60 aria-[invalid=true]:border-red-500',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
